import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson } from '@factorialco/f0-react'
import {
  FilterType,
  buildMyTrainingRequestsDatatableFilter,
  useMyTrainingRequestsDatatable,
} from 'generated/resources/datatable.graphql'
import { TrainingEmployeeForSelectFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const applicantFilter = ({
  source,
  employees,
}: {
  source: ReturnType<typeof useMyTrainingRequestsDatatable>
  employees: TrainingEmployeeForSelectFragment[]
}) => {
  const options = employees
    .map((employee) => {
      if (!employee.access) return

      return {
        label: employee.fullName,
        value: employee.access.id,
        component: (
          <Box flexDirection="row" alignItems="center" gap="s8">
            <F0AvatarPerson
              size="small"
              firstName={employee.fullName}
              lastName={''}
              src={employee.avatar?.url}
            />
          </Box>
        ),
      }
    })
    .filter(Boolean)

  return buildMyTrainingRequestsDatatableFilter(source, {
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'applicantFilter',
    path: 'authorId',
    title: i18n.t('trainings.training_requests.requests.datatable.filters.applicant'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingRequest.filterMyRequests, { filter_used: 'Applicant' })
    },
  })
}
